import { gql } from '@apollo/client'
import employeeWithBuFragment from '../../employee/fragments/employeeWithBu.fragment'

export const POSSIBLE_REVIEWEES_BY_REVIEWER_ID = gql`
  query possibleRevieweesByReviewerId($employeeId: HashedId!, $companyId: HashedId!) {
    possibleRevieweesByReviewerId(employeeId: $employeeId, companyId: $companyId) {
      ...EmployeeWithBu
    }
  }
  ${employeeWithBuFragment}
`
